/*
         * @ngdoc function
         * @name ePay.Model:Session_ErrorHandlerModel
         * @description
         * Model
         */

export class Session_ErrorHandlerModel {
  name: string | null | undefined;
  message: string | null | undefined;
  stack: string | null | undefined;

	constructor(
		name?: string, 
		message?: string, 
		stack?: string
	) {
		this.name = name || null;
		this.message = message || null;
		this.stack = stack || null;
	}
}
